/**
 * Feature Flag Overrides
 *
 * Local-storage persistence for dev-only feature flag overrides, used by the
 * Feature Flags panel (FeatureFlagsNavItem). Overrides are applied on top of
 * the evaluated flags by FeatureFlagProvider on load.
 */

export interface FeatureFlagOverrides {
  [key: string]: boolean;
}

const STORAGE_KEY = 'fflip_overrides';

export function loadOverrides(): FeatureFlagOverrides {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
}

export function saveOverrides(overrides: FeatureFlagOverrides): void {
  try {
    if (Object.keys(overrides).length === 0) {
      localStorage.removeItem(STORAGE_KEY);
    } else {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(overrides));
    }
  } catch {
    // Ignore storage errors
  }
}
